const TableHeader = {
    'Candidates': [
        {
            Name: 'Transformare',
            Type: 'button',
            Editable: '0'
        },
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Status', 
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Data_aplicare',
            Type: 'date',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Prenume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Telefon',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Email', 
            Type: 'email',
            Editable: '1'
        },
        {
            Name: 'Anul_nasterii',
            Type: 'number',
            Editable: '0'
        },
        {
            Name: 'Ocupatie',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Email1',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Rezultat1',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Email2',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Rezultat2',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'SMS',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Rezultat3',
            Type: 'string',
            Editable: '1'
        }
        
    ],
    'Volunteers': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Numar_contract',
            Type: 'number',
            Editable: '1'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Prenume',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Telefon',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Email',
            Type: 'email',
            Editable: '1'
        },
        {
            Name: 'Anul_nasterii',
            Type: 'number',
            Editable: '1'
        },
        {
            Name: 'Ocupatie',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Data_semnare',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Data_expirare',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Adeverinta',
            Type: 'button',
            Editable: '0'
        },
        {
            Name: 'Scan_contract',
            Type: 'button',
            Editable: '0'
        }
        
    ],
    'Admini': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Coordonator',
            Type: 'checkbox',
            Editable: '1'
        },
        {
            Name: 'Recrutor',
            Type: 'checkbox',
            Editable: '1'
        },
        {
            Name: 'Admin',
            Type: 'checkbox',
            Editable: '1'
        },
        {
            Name: 'Stergere',
            Type: 'button',
            Editable: '0'
        }        
    ],
    'PastActivities': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Data_inceput',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Data_sfarsit',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Domeniu',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Descriere',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Locatie',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Ora_inceput',
            Type: 'time',
            Editable: '1'
        },
        {
            Name: 'Ora_final',
            Type: 'time',
            Editable: '1'
        },
        {
            Name: 'Necesar',
            Type: 'number',
            Editable: '1'
        },
        /*{
            Name: 'Stergere',
            Type: 'button',
            Editable: '0'
        }*/
    ],
    'FutureActivities': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Data_inceput',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Data_sfarsit',
            Type: 'date',
            Editable: '1'
        },
        {
            Name: 'Domeniu',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Descriere',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Locatie',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Ora_inceput',
            Type: 'time',
            Editable: '1'
        },
        {
            Name: 'Ora_final',
            Type: 'time',
            Editable: '1'
        },
        {
            Name: 'Necesar',
            Type: 'number',
            Editable: '1'
        },
        {
            Name: 'Stergere',
            Type: 'button',
            Editable: '0'
        }
    ],
    'ActivitiesToValidate': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Data_inceput',
            Type: 'date',
            Editable: '0'
        },
        {
            Name: 'Data_sfarsit',
            Type: 'date',
            Editable: '0'
        },
        {
            Name: 'Domeniu',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Descriere',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Locatie',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Ora_inceput',
            Type: 'time',
            Editable: '0'
        },
        {
            Name: 'Ora_final',
            Type: 'time',
            Editable: '0'
        },
        {
            Name: 'Inchidere',
            Type: 'button',
            Editable: '0'
        }
    ],
    'Announcements': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Data',
            Type: 'date',
            Editable: '0'
        },
        {
            Name: 'Titlu',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Continut',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Stergere',
            Type: 'button',
            Editable: '0'
        }
    ],
    'Courses': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Domeniu',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Durata',
            Type: 'number',
            Editable: '1'
        },
        {
            Name: 'Descriere',
            Type: 'string',
            Editable: '1'
        },
        {
            Name: 'Numar_minim',
            Type: 'number',
            Editable: '1'
        },
        {
            Name: 'Numar_maxim',
            Type: 'number',
            Editable: '1'
        },
        {
            Name: 'Stergere',
            Type: 'button',
            Editable: '0'
        }
    ],
    'ActivitiesForVolunteer': [
        {
            Name: 'Domeniu',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Locatie',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Data',
            Type: 'date',
            Editable: '0'
        },
        {
            Name: 'Durata',
            Type: 'string',
            Editable: '0'
        },

    ],
    'VolunteersAtPastActivity': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Ora_sosire',
            Type: 'time',
            Editable: '0'
        },
        {
            Name: 'Ora_plecare',
            Type: 'time',
            Editable: '0'
        },
        {
            Name: 'Stergere',
            Type: 'button',
            Editable: '0'
        }
    ],
    'VolunteersAtFutureActivity': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Telefon',
            Type: 'number',
            Editable: '0'
        }
    ],
    'ValidatePresence': [
        {
            Name: 'Nr_Crt',
            Type: 'hidden',
            Editable: '0'
        },
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Ora_sosire',
            Type: 'time',
            Editable: '1'
        },
        {
            Name: 'Ora_plecare',
            Type: 'time',
            Editable: '1'
        },
        {
            Name: 'Aprobat',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Stergere',
            Type: 'button',
            Editable: '0'
        }
    ],
    'VolunteersAtCourse': [
        {
            Name: 'Nume',
            Type: 'string',
            Editable: '0'
        },
        {
            Name: 'Data',
            Type: 'date',
            Editable: '0'
        }
    ]
}

export default TableHeader;


// WEBPACK FOOTER //
// ./src/reducers/ReducerTableHeader.js